import React from "react";

const Logout = () => {
    const login = () => {
        const jsonData = {
          /*** 7116 */
            app: "Talk",
            action: "flex-relogin",
            url:window.appConfig.oauth.redirectUrl
          };
          window.parent.postMessage(
            jsonData,
            window.appConfig.sfwyUrl
          );
    }
    
    return (
        <div className="logoutBtnDiv">
          <button className="logoutBtn" onClick={login}>
            Log In Again
        </button>
        </div>
    )
};

export default Logout;
    